import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  PeriodontogramaConfigService,
  PeriodontogramaConfig,
} from "app/services/periodontograma-config.service";

@Component({
  selector: "app-periodontograma-config",
  templateUrl: "./periodontograma-config.component.html",
  styleUrls: ["./periodontograma-config.component.scss"],
})
export class PeriodontogramaConfigComponent implements OnInit {
  umbrales: { desde: number; color: string }[] = [];
  colores: { sangrado: string; supuracion: string; placa: string } = {
    sangrado: "#e53935",
    supuracion: "#ff9800",
    placa: "#1976d2",
  };
  guardando = false;

  constructor(
    private configService: PeriodontogramaConfigService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.configService.cargar().subscribe(() => {
      const cfg = this.configService.config;
      this.umbrales = JSON.parse(JSON.stringify(cfg.umbralesSondaje));
      this.colores = { ...cfg.colores };
    });
  }

  agregarUmbral(): void {
    const ultimo = this.umbrales.length ? this.umbrales[this.umbrales.length - 1].desde + 1 : 4;
    this.umbrales.push({ desde: ultimo, color: "#999999" });
  }

  quitarUmbral(i: number): void {
    this.umbrales.splice(i, 1);
  }

  guardar(): void {
    const ordenados = [...this.umbrales].sort((a, b) => a.desde - b.desde);
    const payload: PeriodontogramaConfig = {
      umbralesSondaje: ordenados,
      colores: this.colores,
    };
    this.guardando = true;
    this.configService.guardar(payload).subscribe({
      next: () => {
        this.guardando = false;
        this.snackBar.open("Configuración guardada", "OK", { duration: 3000 });
      },
      error: () => {
        this.guardando = false;
        this.snackBar.open("Error al guardar", "OK", { duration: 4000 });
      },
    });
  }
}
